import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import { push } from 'react-router-redux'
import InventoryActions, { InventoryRedux, InventoryTypes } from '../Redux/InventoryRedux'
import ClassroomActions from '../Redux/ClassroomRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'

const inventoryCrudObservable = createCRUDObservable({
  mainRedux: InventoryRedux,
  reduxPath: 'inventory',
})

const postCheckInEpic = (action$, store, { Api }) =>
  action$.ofType(InventoryTypes.postCheckInRequest)
    .mergeMap(({ checkin_id, data }) => (
      Observable
        .fromPromise(Api.checkin.postCheckIn(checkin_id, data)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [InventoryActions.postCheckInFailure(response.error)]
          }
          const { data: { data: checkInfo } } = response
          return [
            InventoryActions.postCheckInSuccess(checkInfo),
            notificationSuccess('Formato de Entrada llenado'),
            ClassroomActions.updateDataAfterCheckin(checkInfo),
          ]
        })
    ))

const postCheckOutEpic = (action$, store, { Api }) =>
  action$.ofType(InventoryTypes.postCheckOutRequest)
    .mergeMap(({ checkin, data, isTeacher }) => (
      Observable
        .fromPromise(Api.checkout.postCheckOut(checkin.id, data)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [InventoryActions.postCheckOutFailure(response.error)]
          }
          const { data: { data: checkOutInfo } } = response
          return [
            InventoryActions.postCheckOutSuccess(checkin, checkOutInfo),
            notificationSuccess('Formato de Salida llenado'),
            ClassroomActions.updateDataAfterCheckout(checkOutInfo, isTeacher),
            ClassroomActions.getTotalStudents(),
          ]
        })
    ))

const getStudentByNameEpic = (action$, store, { Api }) =>
  action$.ofType(InventoryTypes.getStudentByNameRequest)
    .mergeMap(({ name }) => (
      Observable
        .fromPromise(Api.checkin.searchStudent(name)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              InventoryActions.getStudentByNameFailure(response.error),
              notificationFail(response.error),
            ]
          }

          return [InventoryActions.getStudentByNameSuccess(response.data.data)]
        })
    ))

export const inventoryObservers = Object.assign({}, inventoryCrudObservable.observers, {
  postCheckInEpic,
  postCheckOutEpic,
})

export const inventoryEpic = combineEpics(
  inventoryCrudObservable.epic,
  postCheckInEpic,
  postCheckOutEpic,
  getStudentByNameEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/InventoryObservable.js